import { Component } from '@angular/core';
import { SidebarService } from '../../service/sidebar.service';

@Component({
  selector: 'fxch-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  sidebarExpanded = true;

  constructor(public readonly sidebarService: SidebarService) {
  }

  toggle() {
    this.sidebarExpanded = !this.sidebarExpanded;
    this.sidebarService.toggleSidebar.emit(this.sidebarExpanded)
  }
}
